import { Injectable } from '@angular/core';
import { CLIService } from '../cli/cli.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private _showOnCLI = true;

  constructor(private readonly cliService: CLIService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public log(...args: any[]): void {
    if (this._suppress()) {
      return;
    }

    // eslint-disable-next-line no-console
    console.log(...args);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public info(...args: any[]): void {
    if (this._suppress()) {
      return;
    }

    if (typeof args[0] !== 'object' && typeof args[0] !== 'function') {
      args[0] = `%c ${args[0]}`;
      args.splice(1, 0, 'background-color: #ecf1f8; color: #0d6efd;');
      // eslint-disable-next-line no-console, no-restricted-syntax
      console.info(...args);
    } else {
      // eslint-disable-next-line no-console, no-restricted-syntax
      console.info(...args);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public warn(...args: any[]): void {
    if (this._suppress()) {
      return;
    }

    // eslint-disable-next-line no-console
    console.warn(...args);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public error(...args: any[]): void {
    if (this._suppress()) {
      return;
    }

    // eslint-disable-next-line no-console
    console.error(...args);
  }

  private _suppress(): boolean {
    return !this._showOnCLI;
  }
}
